<template>
  <div>
    <form @submit.prevent="submit">
      <div class="modal-header">
        <button type="button" class="close" @click="hideModal()" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title">Dodaj posiłek do dnia {{ day.date | format_date }}</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-xs-12">
            <div
              class="alert alert-danger"
              v-if="afterFirstAttempt && ($v.time.$error || $v.name.$error || $v.kcal.$error)"
            >
              <div class="" v-if="afterFirstAttempt && !$v.time.required && $v.time.$error">Godzina jest wymagana.</div>
              <div class="" v-if="afterFirstAttempt && !$v.name.required && $v.name.$error">
                Nazwa posiłku jest wymagana.
              </div>
              <div class="" v-if="afterFirstAttempt && !$v.name.minLength && $v.name.$error">
                Nazwa posiłku musi mieć przynajmniej {{ $v.name.$params.minLength.min }} znaków.
              </div>

              <div class="" v-if="afterFirstAttempt && !$v.kcal.required && $v.kcal.$error">
                Kaloryczność jest wymagana.
              </div>
              <div class="" v-if="afterFirstAttempt && !$v.kcal.between && $v.kcal.$error">
                Kaloryczność musi zawierać się w granicach {{ $v.kcal.$params.between.min }} -
                {{ $v.kcal.$params.between.max }} kcal.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-3">
            <label>Godzina</label>
            <div class="form-group" :class="{ 'form-group--error': afterFirstAttempt && $v.time.$error }">
              <input type="time" class="form-control form-control-xs" v-model.trim="$v.time.$model" />
            </div>
          </div>
          <div class="col-xs-6">
            <label>Nazwa</label>
            <div class="form-group" :class="{ 'form-group--error': afterFirstAttempt && $v.name.$error }">
              <input type="text" class="form-control form-control-xs" v-model.trim="$v.name.$model" />
            </div>
          </div>
          <div class="col-xs-3">
            <label>Kaloryczność</label>
            <div class="form-group" :class="{ 'form-group--error': afterFirstAttempt && $v.kcal.$error }">
              <input
                type="number"
                class="form-control form-control-xs"
                min="1"
                step="1"
                v-model.trim="$v.kcal.$model"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-default" @click="hideModal()">Zamknij</button>
        <button class="btn btn-success pull-right" type="submit" :disabled="afterFirstAttempt && this.$v.$invalid">
          Dodaj
        </button>
      </div>
    </form>
  </div>
</template>

<style scoped>
.in {
  display: block;
}
</style>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { planFactory } from '../../../factory/plan.factory';
import uuid from 'uuid4';
import { between, minLength, required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      afterFirstAttempt: false,
      day: null,
      time: null,
      name: null,
      kcal: null,
    };
  },
  computed: {
    ...mapState({
      modalData: (state) => state.modal.data,
    }),
    ...mapGetters(['getDayById']),
  },
  methods: {
    ...mapMutations(['hideModal']),
    submit() {
      this.afterFirstAttempt = true;
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.day.addPlan(planFactory.create(uuid(), this.name, this.kcal, this.time, '', [], [], this.day.date));
      this.resetFields();
      this.hideModal();
    },

    resetFields() {
      this.name = null;
      this.kcal = null;
      this.time = null;
      this.$v.$reset();
    },
  },
  watch: {
    modalData: {
      immediate: true,
      handler: function (data) {
        if (!data) return;
        this.resetFields();
        this.day = this.getDayById(data.dayId);
      },
    },

    time(value) {
      this.time = value.replace(';', ':');
    },
  },
  validations: {
    time: {
      required,
      regex: (value) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value),
    },
    name: {
      required,
      minLength: minLength(4),
    },
    kcal: {
      required,
      between: between(5, 3000),
    },
  },
};
</script>
